import { GzGenericWidget } from './component/GzGenericWidget';
import { GzGenericWidgetContent } from './component/GzGenericWidgetContent';

export { GzGenericWidget, GzGenericWidgetContent };
